import get from 'lodash/get';

export const formatSaveBrowserSearchRequest = ({
  searchParameters,
  countryCode,
  verticalId,
  subscriptionId = '',
}) => ({
  data: {
    type: 'search',
    attributes: {
      site: {
        country_code: countryCode,
        vertical_id: verticalId,
      },
      query: {
        what: get(searchParameters, 'what_d'),
        filters: get(searchParameters, 'filters'),
        vertical_properties: {
          deal_type_id: get(searchParameters, 'type_id'),
          where: get(searchParameters, 'where'),
          suggester: get(searchParameters, 'suggester'),
        },
      },
      active: true,
    },
    relationships: {
      subscription: {
        data: {
          type: 'subscription',
          id: subscriptionId,
        },
      },
    },
  },
});

export const formatUpdateBrowserSearchRequest = ({ searchParameters, searchId, isActive }) => ({
  data: {
    type: 'search',
    id: searchId,
    attributes: {
      query: {
        filters: get(searchParameters, 'filters'),
      },
      active: isActive,
    },
  },
});

export const formatSuscribeUserRequest = ({
  searchParameters,
  installationId,
  countryCode,
  verticalId,
  subscription,
}) => {
  const browserSearchRequest = formatSaveBrowserSearchRequest({
    searchParameters,
    verticalId,
    countryCode,
  }).data;
  delete browserSearchRequest.relationships;
  return {
    data: {
      type: 'subscription',
      attributes: {
        site: {
          country_code: countryCode,
          vertical_id: verticalId,
        },
        device_id: 2,
        browser_connection: {
          endpoint: subscription.toJSON().endpoint,
          auth_keys: {
            public_key: subscription.toJSON().keys.p256dh,
            auth_token: subscription.toJSON().keys.auth,
          },
        },
        cookie_id: installationId,
        unsubscribed: false,
        active: true,
      },
    },
    included: [browserSearchRequest],
  };
};

export const formatUpdateUserSubscription = (subscriptionId, subscription) => ({
  data: {
    type: 'subscription',
    id: subscriptionId,
    attributes: {
      browser_connection: {
        endpoint: subscription.toJSON().endpoint,
        auth_keys: {
          public_key: subscription.toJSON().keys.p256dh,
          auth_token: subscription.toJSON().keys.auth,
        },
      },
    },
  },
});

export const formatSaveAlertRequest = (
  searchParameters,
  trovit,
  config,
  userData,
  totalResults,
  section
) => ({
  data: {
    type: 'subscription',
    attributes: {
      site: {
        country_code: config.countryCode,
        vertical_id: config.verticalId,
      },
      user: {
        ...userData,
      },
    },
  },
  included: [
    {
      type: 'search',
      attributes: {
        site: {
          country_code: config.countryCode,
          vertical_id: config.verticalId,
        },
        query: {
          what: get(searchParameters, 'what_d') || '',
          filters:
            {
              ...get(searchParameters, 'filters'),
              ...(get(searchParameters, 'geoId')
                ? { geo_id: get(searchParameters, 'geoId') }
                : null),
            } || [],
          vertical_properties: {
            deal_type_id: get(searchParameters, 'type_id'),
            where: get(searchParameters, 'where'),
            suggester: get(searchParameters, 'suggester'),
          },
        },
        notification: {
          frequency: 'daily',
          features: [], // @TODO : fill with main info of the last ad visited (rooms, price, ...)
          active: true,
          suggested: false,
        },
        context: {
          section_id: section,
          origin_id: trovit.origin,
          device_type: get(searchParameters, 'device'),
          total_results: totalResults,
        },
      },
    },
  ],
});

/**
 * Fallback to empty string query param when vv is null
 * @param {String} vv
 */
export function addVVEmptyString(vv) {
  return vv ? '' : '&vv=';
}



// WEBPACK FOOTER //
// ./app/sdk/notifications/utils.js